<script>
  import { onMount, tick } from 'svelte';
  import Zoom from './Zoom.svelte'
  import Article from './ArticleRub.svelte'
  import { getPgCount, getArticles, setArticles, setState, setUrl } from './logic'
  import { logged, page, pagenum } from './stores'
  import Paging from './Paging.svelte';
  
  export let issue
  export let modified = false

  const index = 'articles'
  let pgCount = 2
  // let left = 1
  let right = 2
  let data
  let error
  let state = {add: false, rub: []}
  
  onMount(async () => {
    await get()
  })
  
  async function get() {
    ({ error, data } = await getArticles(issue.id, index))
    console.log('get', data, error)
    
    if (data) {
      state.add = false
      state.del = false
      state.last = -1
      pgCount = getPgCount(data)
      let rubcount = 0
      let rubref = {}
      // for (let art of data) {
      for (let i=0; i<data.length; i++) {
        let art = data[i]
        state.rub[i] = {}
        let rub = state.rub[i]
        rub.i = i+1
        rubref[art.id] = i
        for (let block of art.groups) {
          if (!rub.rubric && block.type==='rubric') {
            rub.enabled = true
            rub.seq = ++rubcount
            console.log('art',rub)
          }
        }
      }
      console.log('rubref',rubref)
      // for (let art of data) {
      for (let i=0; i<data.length; i++) {
        let art = data[i]
        let rub = state.rub[i]
        if (rub.enabled) {
          // console.log('rubid1',art, rub)
          for (let rubid of art.rubricParts) {
            console.log('rubid',rubid)
            if (rubref[rubid]) {
              let tmp = state.rub[rubref[rubid]]
              tmp.seq = rub.seq
              tmp.index = i
              console.log('art2',tmp)
            }
          }
        }
      }
    await tick()
    modified = false
    }
  }

  async function setArticle() {
    error = await setArticles(data, issue.id, index)
    console.log('res1', error)
    if (!error) { 
      modified = false
      error = await setState(issue.id, 'checking', $logged)
      console.log('res1b', error)
    }
  }
    
  $: right = $pagenum + 1
  $: if (right === $pagenum) right = $pagenum + 1
  $: if (data) modified = true
</script>
     
<div>
  Uloženo:
  <span class="ready" class:modified>{modified? 'ne' : 'ano'}</span>    
  <input type="button" class="btn btn-green py-0.5" value="uložit" on:click|preventDefault={setArticle} />
  <!-- <input class="right" type="button" value="reset" disabled={!modified} on:click|preventDefault={get} /> -->
  {#if error}<span class="error">{error}</span>{/if}
</div>

<div class="state mb-2 h-8">
  Stav:
  {#if state.add}
    přidání čláku <span class="from px-1.5">?</span> do rubriky <span class="split">+{state.num}</span>
    <input type="button" class="btn btn-green py-0.5" value="přerušit / dokončit" on:click|preventDefault={() => {state.add = false; state.last = -1}} />
  {:else if state.del}
    odebrání článku z rubriky <span class="from del">-{state.num}</span>
    <input type="button" class="btn btn-green py-0.5" value="přerušit / dokončit" on:click|preventDefault={() => {state.del = false; state.last = -1}} />
  {/if}
</div>
<!-- {JSON.stringify(data)} -->
<!-- {modified} {data?.length} {JSON.stringify(state)} {pgCount} -->

{#if data}	
  <div class="ln:flex">
    <div class="ln:w-1/2 ln:mr-2">
      <Zoom src="/issue/{issue.id}/{$pagenum}" height="400" let:params            
      >
        <!-- {JSON.stringify(params)} {issue.id} {$pagenum} -->
        <Article bind:articles={data} bind:state page={$pagenum} {...params} />
      </Zoom>
      <Paging id={issue.id} {pgCount} center/>
    </div>
    <div class="ln:w-1/2 ln:ml-2">
      <Zoom src="/issue/{issue.id}/{right}" hide={right > pgCount} let:params>
        <Article bind:articles={data} bind:state page={right} {...params} />
      </Zoom>
      <Paging bind:counter={right} {pgCount} center/>
    </div>
  </div>
{/if}
    
<style>
  .del {
    background-color: red;
}
</style>